const toAction = (type = 'NO TYPE PROVIDED', payload = 'NO PAYLOAD PROVIDED') => ({ type, payload });

export default toAction;
